<template>
  <v-dialog
    v-model="open"
    persistent
    scrollable
    max-width="1024px"
    content-class="tw-rounded-3xl"
  >
    <v-form
      ref="form"
      v-model="valid"
      :disabled="form_disabled_state"
      lazy-validation
      enctype="multipart/form-data"
      @submit.prevent="update"
    >
      <v-card class="tw-rounded-3xl tw-border-0 tw-shadow-md">
        <ModalHeader @close-modal="closeModal">{{
          $t('app.field')
        }}</ModalHeader>
        <v-divider />
        <v-card-text class="tw-p-0" style="max-height: 700px">
          <v-responsive class="tw-py-0">
            <v-container class="tw-bg-gray-100">
              <v-row class="mb-5">
                <v-col cols="12" class="px-5 pt-5 mx-auto">
                  <form-description>
                    <template #title>
                      {{ $t('admin.events.field_settings') }}
                    </template>
                    <template #copy>
                      {{ $t('admin.events.field_settings_description') }}
                    </template>
                  </form-description>
                </v-col>
                <v-col cols="12" class="mx-auto pa-5">
                  <v-card class="mx-auto tw-divide-y tw-divide-gray-200 tw-rounded-3xl tw-shadow-md">
                    <!-- ================ Label - Columns ================ -->
                    <v-container class="tw-p-5 tw-pb-0">
                      <div class="tw-grid tw-grid-cols-3 tw-gap-4">
                        <div class="tw-col-span-2">
                          <v-text-field
                            ref="new_exam"
                            v-model="mountedFormInput.label"
                            :rules="[rules.testEmpty]"
                            validate-on-blur
                            outlined
                            rounded
                            dense
                            color="primary darken-1"
                            :label="$t('app.title')"
                          />
                        </div>
                        <div class="tw-col-span-1">
                          <v-select
                            v-model="mountedFormInput.cols"
                            :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                            outlined
                            rounded
                            dense
                            :label="$t('app.width')"
                          />
                        </div>
                      </div>
                    </v-container>
                    <!-- ================ Atributos ================ -->
                    <v-container class="tw-p-5 tw-pb-0">
                      <div>
                        <h3 class="tw-text-lg tw-font-medium tw-leading-6 tw-text-gray-900">
                          {{ $t('app.attributes') }}
                        </h3>
                        <p class="tw-mt-1 tw-mb-0 tw-text-sm tw-text-gray-500">
                          {{ $t('admin.app.extra_config_description') }}
                        </p>
                      </div>
                      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-w-full tw-pt-2 tw-pb-6">
                        <div>
                          <v-switch
                            v-model="mountedFormInput.is_active"
                            :label="$t('app.active')"
                            color="primary"
                            dense
                            inset
                            hide-details
                            class="tw-m-0"
                          />
                        </div>
                        <div>
                          <v-switch
                            v-model="mountedFormInput.is_required"
                            :disabled="!mountedFormInput.is_active"
                            :label="$t('app.required')"
                            color="primary"
                            inset
                            dense
                            hide-details
                            class="tw-m-0"
                          />
                        </div>
                        <div>
                          <v-switch
                            v-model="mountedFormInput.is_public"
                            :disabled="!mountedFormInput.is_active"
                            :label="$t('app.on_card')"
                            color="primary"
                            inset
                            dense
                            hide-details
                            class="tw-m-0"
                          />
                        </div>
                        <div>
                          <v-switch
                            v-model="mountedFormInput.hasVisibility"
                            :disabled="!mountedFormInput.is_active"
                            :label="$t('app.on_config')"
                            color="primary"
                            inset
                            dense
                            hide-details
                            class="tw-m-0"
                          />
                        </div>
                        <div>
                          <v-switch
                            v-if="mountedFormInput.field_type == 'checkbox'"
                            v-model="mountedFormInput.isValidationForm"
                            :disabled="!mountedFormInput.is_active"
                            :label="$t('terms.is_part_of_terms')"
                            color="primary"
                            inset
                            dense
                            hide-details
                            class="tw-m-0"
                          />
                        </div>
                        <div>
                          <v-switch
                            v-if="mountedFormInput.hasVisibility"
                            v-model="mountedFormInput.isLeadSource"
                            :disabled="!mountedFormInput.is_active"
                            label="Lead Source"
                            color="primary"
                            inset
                            dense
                            hide-details
                            class="tw-m-0"
                          />
                        </div>
                      </div>
                    </v-container>
                    <!-- ========== Config to condition ========== -->
                    <v-container v-if="mountedFormInput.hasVisibility" class="tw-bg-gray-50 tw-p-5">
                      <div class="tw-grid tw-grid-cols-2 tw-gap-3">
                          <div class="tw-col-span-2 md:tw-col-span-1">
                            <v-select
                              v-model="mountedFormInput.visibility.mode"
                              :items="['always', 'depends_on', 'hidden']"
                              filled
                              single-line
                              rounded
                              :label="$t('bz2.form_register.mode')"
                              hide-details
                              clearable
                              dense
                            />
                          </div>
                          <div v-if="mountedFormInput.visibility.mode == 'hidden'" class="tw-col-span-2 md:tw-col-span-1">
                            <v-text-field
                              ref="mode"
                              v-model="mountedFormInput.model"
                              validate-on-blur
                              filled
                              single-line
                              rounded
                              color="primary darken-1"
                              :label="$t('bz2.form_register.value')"
                              placeholder="model"
                              hide-details
                              dense
                            />
                          </div>
                          <div v-if="mountedFormInput.visibility.mode == 'depends_on' || mountedFormInput.visibility.mode == 'hidden' && !mountedFormInput.model" class="tw-col-span-2 md:tw-col-span-1">
                            <v-select 
                              v-model="mountedFormInput.visibility.field"
                              :items="possibleParents"
                              item-text="label"
                              item-value="name"
                              :label="$t('bz2.form_register.depends_on')"
                              hide-details
                              clearable
                              dense
                              filled
                              single-line
                              rounded
                            />
                          </div>
                          <div v-if="parentOptions.length && mountedFormInput.visibility.mode !== 'hidden'" class="tw-col-span-2 md:tw-col-span-1">
                            <v-select
                              v-model="mountedFormInput.visibility.value"
                              :items="parentOptions"
                              item-text="label"
                              item-value="value"
                              :label="$t('bz2.form_register.when_the_value_is')"
                              hide-details
                              clearable
                              dense
                              filled
                              single-line
                              rounded
                            />
                          </div>

                          <div v-if="mountedFormInput.visibility.mode == 'hidden' && !mountedFormInput.model" class="tw-col-span-2 tw-bg-gray-200/50 tw-p-4 tw-rounded-lg">
                            <h4 class="tw-text-gray-400 tw-mb-2 tw-leading-tight">Valores dinámicos</h4>
                            <div v-for="(map, i) in mountedFormInput.defaultMapping" :key="i" class="tw-flex tw-items-center tw-space-x-2 tw-mb-3">
                              <!-- ==== Valor padre ==== -->
                              <v-select
                                v-model="map.parentValue"
                                :items="parentOptionsFor(mountedFormInput.visibility.field)"
                                item-text="label"
                                item-value="value"
                                :label="$t('bz2.form_register.courage_father')"
                                hide-details
                                clearable
                                dense
                                filled
                                single-line
                                rounded
                                class="tw-flex-1"
                              />
                              <v-text-field
                                v-model="map.model"
                                :label="$t('bz2.form_register.then_value_will_be')"
                                hide-details
                                clearable
                                dense
                                filled
                                single-line
                                rounded
                                class="tw-flex-1"
                              />
                              <v-btn fab small icon color="error" @click="deleteMapping(map)">
                                <v-icon class="tw-text-lg tw-text-red-400">delete</v-icon>
                              </v-btn>
                            </div>
                            <v-btn rounded color="white" class="tw-normal-case tw-shadow tw-font-bold" @click="addMapping">
                              <v-icon class="tw-text-lg tw-mr-1">add</v-icon>
                              {{ $t('app.add_rule') }}
                            </v-btn>
                          </div>
                      </div>
                    </v-container>
                    <!-- ========== Config part terms ========== -->
                    <v-container v-if="mountedFormInput.isValidationForm" class="tw-bg-gray-50 tw-p-5">
                      <div class="tw-grid tw-grid-cols-1 tw-gap-3">
                        <v-text-field
                          v-model="mountedFormInput.contentValidation.text"
                          validate-on-blur
                          filled
                          single-line
                          rounded
                          color="primary darken-1"
                          label="Texto"
                          placeholder="Texto"
                          hide-details
                          dense
                        />
                        <v-text-field
                          v-model="mountedFormInput.contentValidation.text_link"
                          validate-on-blur
                          filled
                          single-line
                          rounded
                          color="primary darken-1"
                          label="Texto link"
                          placeholder="Texto link"
                          hide-details
                          dense
                        />
                        <v-text-field
                          v-model="mountedFormInput.contentValidation.link"
                          validate-on-blur
                          filled
                          single-line
                          rounded
                          color="primary darken-1"
                          label="Link"
                          placeholder="Link"
                          hide-details
                          dense
                        />
                      </div>
                    </v-container>
                    <!-- ================ Rules ================ -->
                    <v-container class="tw-p-5 tw-bg-gray-50 tw-space-y-2">
                      <div>
                        <h3 class="tw-text-lg tw-font-medium tw-leading-6 tw-text-gray-900">
                          {{ $t('app.rules') }}
                        </h3>
                        <p class="tw-mt-1 tw-mb-0 tw-text-sm tw-text-gray-500">
                          {{ $t('app.rules_des') }}
                        </p>
                      </div>
                      <div class="tw-flex tw-flex-col tw-gap-3">
                        <div
                          v-for="(v, i) in mountedFormInput.rules"
                          :key="i" 
                          class="tw-flex tw-flex-col md:tw-flex-row tw-w-full flex-1 tw-gap-3"
                        >
                          <v-select
                            v-model="v.type"
                            :items="rulesList"
                            item-text="label"
                            item-value="value"
                            label="Tipo de regla"
                            dense
                            clearable
                            filled
                            single-line
                            rounded
                            hide-details
                          />
                          <v-text-field
                            v-if="!['required','number','phone','email','dependent'].includes(v.type) && v.type"
                            v-model="v.param"
                            label="Parámetro"
                            dense
                            clearable
                            filled
                            flat
                            single-line
                            rounded
                            hide-details
                          />
                          <v-text-field
                            v-if="!['dependent'].includes(v.type) && v.type"
                            v-model="v.message"
                            label="Mensaje (opcional)"
                            dense
                            clearable
                            filled
                            single-line
                            rounded
                            hide-details
                          />
                          <!-- ===== Depende de con rules ===== -->
                          <div v-if="v.type == 'dependent'" class="tw-grid tw-grid-cols-1 tw-gap-3">
                            <v-select
                              v-model="v.dependentField"
                              :items="possibleParents"
                              item-text="label"
                              item-value="name"
                              label="Campo dependiente"
                              dense
                              clearable
                              filled
                              single-line
                              rounded
                              hide-details
                            />

                            <div v-if="v.dependentField" class="tw-mt-2">
                              <div class="tw-font-medium tw-text-sm tw-mb-2 tw-text-gray-700">Configurar reglas por valor</div>
                              <div v-for="(ruleset, index) in v.valueRules" :key="index" class="tw-mb-4 tw-p-6 tw-bg-gray-100 tw-rounded-lg">
                                <div class="tw-flex tw-items-center tw-justify-between tw-mb-2">
                                  <div class="tw-font-medium tw-text-sm">Cuando el valor es:</div>
                                  <v-btn small icon color="error" @click="deleteValueRule(v, index)">
                                    <v-icon class="tw-text-sm tw-text-red-400">delete</v-icon>
                                  </v-btn>
                                </div>
                                
                                <v-select
                                  v-model="ruleset.parentValue"
                                  :items="parentOptionsForField(v.dependentField)"
                                  item-text="label"
                                  item-value="value"
                                  label="Valor del campo dependiente"
                                  dense
                                  clearable
                                  filled
                                  single-line
                                  rounded
                                  hide-details
                                  class="tw-mb-2"
                                />
                                
                                <v-select
                                  v-model="ruleset.ruleType"
                                  :items="rulesList"
                                  item-text="label"
                                  item-value="value"
                                  label="Tipo de regla a aplicar"
                                  dense
                                  clearable
                                  filled
                                  single-line
                                  rounded
                                  hide-details
                                  class="tw-mb-2"
                                />
                                
                                <v-text-field
                                  v-model="ruleset.param"
                                  label="Parámetro de la regla"
                                  dense
                                  clearable
                                  filled
                                  single-line
                                  rounded
                                  hide-details
                                />
                                
                                <v-text-field
                                  v-model="ruleset.message"
                                  label="Mensaje de error"
                                  dense
                                  clearable
                                  filled
                                  single-line
                                  rounded
                                  hide-details
                                  class="tw-mt-2"
                                />
                              </div>
                              
                              <v-btn rounded color="white" class="tw-normal-case tw-shadow tw-font-bold tw-w-1/2" @click="addValueRule(v)">
                                <v-icon class="tw-text-lg tw-mr-1">add</v-icon> {{ $t('app.add_rule') }}
                              </v-btn>
                            </div>

                          </div>
                          <v-btn fab small icon color="error" @click="deleteRule(v)">
                            <v-icon class="tw-text-lg tw-text-red-400">delete</v-icon>
                          </v-btn>
                        </div>
                        <v-btn rounded color="white" class="tw-normal-case tw-shadow tw-font-bold tw-w-1/2 lg:tw-w-1/6" @click="addRule">
                          <v-icon class="tw-text-lg tw-mr-1">add</v-icon> {{ $t('app.add_rule') }}
                        </v-btn>
                      </div>
                    </v-container>
                    <!-- ================ Field Type ================ -->
                    <v-container class="tw-px-5 tw-pt-8 tw-pb-0">
                      <div class="tw-grid tw-w-full tw-grid-cols-3 tw-gap-4">
                        <div class="tw-col-span-2">
                          <v-select
                            v-model="mountedFormInput.field_type"
                            :items="formatFields"
                            item-text="i18_label"
                            item-value="value"
                            outlined
                            rounded
                            dense
                            :label="$t('app.type')"
                          />
                        </div>
                        <div v-if="mountedFormInput.field_type == 'number'" class="tw-col-span-1">
                          <v-text-field
                            v-model="mountedFormInput.characters"
                            :label="$t('app.characters')"
                            type="number"
                            outlined
                            dense
                            rounded
                          />
                        </div>
                      </div>
                    </v-container>
                    <!-- ================ Field Options ================ -->
                    <v-container v-if="hasOptionsField" class="tw-space-y-4 tw-bg-gray-50 tw-px-5">
                      <div v-for="option in mountedFormInput.options" :key="option.uid" class="tw-flex tw-flex-col md:tw-flex-row tw-items-start tw-justify-start tw-gap-3">
                        <div class="tw-w-full flex-1">
                          <v-text-field
                            ref="new_exam"
                            v-model="option.text"
                            :rules="[rules.testEmpty]"
                            validate-on-blur
                            filled
                            single-line
                            dense
                            rounded
                            hide-details
                            :label="$t('app.option')"
                            @blur="onBlurOption(option)"
                          />
                        </div>
                        <div class="tw-w-full flex-1">
                          <v-select
                            v-if="parentOptions.length && !mountedFormInput.visibility.value"
                            v-model="option.visibleWhen"
                            :items="parentOptions"
                            item-text="label"
                            item-value="value"
                            label="Cuando el valor sea"
                            clearable
                            filled
                            single-line
                            dense
                            rounded
                            hide-details
                          />
                        </div>
                        <div class="tw-flex tw-items-center">
                          <div class="tw-ml-1">
                            <v-btn fab small icon color="error" @click="deleteItem(option)">
                              <v-icon class="tw-text-lg tw-text-red-400">delete</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                      <div class="tw-flex tw-justify-start">
                        <v-btn rounded color="white" class="tw-normal-case tw-shadow tw-font-bold" @click="addOption">
                          <v-icon class="tw-text-lg tw-mr-1">add</v-icon>
                          {{ $t('app.add_option') }}
                        </v-btn>
                      </div>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-responsive>
        </v-card-text>
        <v-container>
          <transition name="fade-transition" mode="out-in">
            <v-row v-if="errorAlert">
              <v-col cols="12">
                <v-alert
                  v-model="errorAlert"
                  dismissible
                  color="red"
                  border="left"
                  elevation="2"
                  colored-border
                  icon="error"
                  transition="fade-transition"
                >
                  {{ errorMsg }}</v-alert
                >
              </v-col>
            </v-row>
          </transition>
        </v-container>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            rounded
            :disabled="form_loading"
            class="
              tw-px-8 tw-normal-case
              focus:tw-outline-none focus:tw-ring focus:tw-ring-white
            "
            @click="closeModal"
          >
            {{ $t('app.cancel') }}</v-btn
          >
          <v-btn
            color="primary darken-1"
            rounded
            type="submit"
            :loading="form_loading"
            class="
              text--white text--lighten-4
              tw-px-8 tw-normal-case
              focus:tw-outline-none focus:tw-ring focus:tw-ring-primary-300
            "
          >
            {{ $t('app.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ModalHeader from '@/components/ModalHeader'
import FormDescription from '@/components/FormDescription'
import { mapState } from 'vuex'

// import RadioBtn from "@/components/FormInputs/RadioBtn";
import { FormOption, FormMapping, FormRules } from '@/models/RegistryForm'
import { slugify } from '@/helpers'
export default {
  components: {
    ModalHeader,
    // RadioBtn,
    FormDescription,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    formInput: {
      type: Object,
      default: () => ({}),
    },
    formFields: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    errorAlert: '',
    errorMsg: '',
    exam: '',
    rules: {
      numericZero: (v) => !!parseFloat(v) || 'Campo no puede ser 0',
      testEmpty: (value) => !!value || 'Campo no puede estar vacio.',
      min: (v) => v.length >= 8 || 'Min 8 characters',
      emailMatch: () => "The email and password you entered don't match",
    },
    isLoading: false,
    form_loading: false,
    form_disabled_state: false,
    valid: true,
    mountedFormInput: {},
    isLoadingRooms: false,
    formatFields: [],
  }),
  computed: {
    // ======== Lista de todos los campos disponibles para depender (menos el actual) ======== //
    possibleParents() {
      return this.formFields
        .filter(f => f.uid !== this.mountedFormInput.uid)
        .map(f => ({ label: f.label, name: f.name, field: f }))
    },
    // ======== El campo padre completo, segun lo que haya seleccionado el usuario ======== //
    parentField() {
      return this.possibleParents.find(p => p.name === this.mountedFormInput.visibility.field)?.field
    },
    // ======== El campo padre completo, segun lo que haya seleccionado el usuario ======== //
    parentOptions() {
      return this.parentField && this.parentField.field_type === 'select'
        ? this.parentField.options.map(o => ({ label: o.text, value: o.value }))
        : []
    },
    // ======== Otro ======== //
    hasOptionsField() {
      return ['radio', 'checkbox', 'select'].includes(
        this.mountedFormInput.field_type,
      )
    },
    open: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    ...mapState({
      fields: (state) => state.constants.data.fields,
    }),
    rulesList() {
      return [
        { value: 'required', label: 'Required' },
        { value: 'number', label: 'Number' },
        { value: 'min', label: 'Min' },
        { value: 'max', label: 'Max' },
        { value: 'startsWith', label: 'Start with' },
        { value: 'phone', label: 'Phone' },
        { value: 'email', label: 'E-mail' },
        { value: 'dependent', label: 'Dependent rules' },
      ]
    },
  },
  mounted() {
    // this.mountedFormInput = Object.assign({}, this.formInput)
    this.formatFields = this.fields.map((row) => ({
      ...row,
      i18_label: this.$t(`app.field_select.${row.icon}`),
    }))
    this.mountedFormInput = JSON.parse(JSON.stringify(this.formInput))
    this.mountedFormInput.visibility ||= { mode: '', field: '', value: '' }
    this.mountedFormInput.defaultMapping ||= []
    this.mountedFormInput.isLeadSource ||= false
    this.mountedFormInput.isValidationForm ||= false
    this.mountedFormInput.contentValidation ||= { text: '', text_link: '', link: '' }
  },
  methods: {
    parentOptionsFor(fieldName) {
      // buscamos en formFields (prop del modal) el campo de ese name
      const fld = this.formFields.find(f => f.name === fieldName)
      // si no existe o no es select, devolvemos lista vacía
      if (!fld || fld.field_type !== 'select') return []
      // mapeamos sus options al formato { label, value }
      return fld.options.map(o => ({
        label: o.text,
        value: o.value,
      }))
    },
    parentOptionsForField(fieldName) {
      // Similar a parentOptionsFor, pero para cualquier campo
      const field = this.formFields.find(f => f.name === fieldName)
      if (!field || !['select', 'radio'].includes(field.field_type)) return []
      
      return field.options.map(o => ({
        label: o.text,
        value: o.value,
      }))
    },
    deleteItem(row_deleted) {
      console.log(row_deleted)
      this.mountedFormInput.options = this.mountedFormInput.options.filter(
        (row) => row.uid != row_deleted.uid,
      )
    },
    deleteMapping(row_deleted){
      this.mountedFormInput.defaultMapping = this.mountedFormInput.defaultMapping.filter(
        (row) => row.uid != row_deleted.uid,
      )
    },
    deleteRule(row_deleted) {
      this.mountedFormInput.rules = this.mountedFormInput.rules.filter(
        (row) => row.uid !== row_deleted.uid,
      )
    },
    deleteValueRule(rule, index) {
      rule.valueRules.splice(index, 1)
    },
    onBlurOption(option) {
      // option
      const updated_option = { ...option, value: slugify(option.text) }
      this.mountedFormInput.options = this.mountedFormInput.options.map((row) =>
        row.uid === option.uid ? updated_option : row,
      )
    },
    addOption() {
      this.mountedFormInput.options = [
        ...this.mountedFormInput.options,
        FormOption({}),
      ]
    },
    addMapping() {
      this.mountedFormInput.defaultMapping = [
        ...this.mountedFormInput.defaultMapping,
        FormMapping({}),
      ]
    },
    addRule() {
      // this.mountedFormInput.rules = [
      //   ...this.mountedFormInput.rules,
      //   FormRules({}),
      // ]
      const newRule = FormRules({})
  
      // Añadir propiedades adicionales para reglas dependientes
      newRule.dependentField = ''
      newRule.valueRules = []
      
      this.mountedFormInput.rules = [
        ...this.mountedFormInput.rules,
        newRule,
      ]
    },
    addValueRule(rule) {
      // Si no existe la propiedad valueRules, la inicializamos
      if (!rule.valueRules) {
        this.$set(rule, 'valueRules', [])
      }
      
      // Añadimos una nueva regla por valor
      rule.valueRules.push({
        parentValue: '',
        ruleType: '',
        param: '',
        message: '',
      })
    },
    closeModal() {
      this.open = false
    },
    update() {
      this.errorAlert = false
      if (!this.$refs.form.validate()) {
        return
      }
      this.mountedFormInput.name = slugify(this.mountedFormInput.label)
      this.$emit('updated-form-input', this.mountedFormInput)
      this.open = false
    },
  },
}
</script>

<style></style>
